/* MXDVS scroll reveal: assets/mxdvs-scroll-reveal.js (MOBILE 2, points 8 + 9)
   Every page, phones and desktop. Loaded by sections/mxdvs-menu-terminal.liquid (header group).
   9. The floating glass header (sections/mxdvs-rail.liquid, [data-mxh]) and its news strip ([data-mxh-nb])
      slide up out of view while the page scrolls down and slide back in on the first scroll up.
      From the top of a page (white header, or the homepage video) the first scroll down takes it away
      straight away, so the floating bar never flashes in on the way down. On the homepage the bar that
      would slide in at the end of the video stays out of view while you keep scrolling down.
      It stays while a menu, the search or the country list is open.
      The follow delay is off on desktop and phones (mxdvs-scroll-reveal.css).
   8. The back to top button (snippets/back-to-top.liquid) shows and fades together with the floating header:
      same moment, same duration. Never with the white header at the top or the homepage header over the video.
   Nothing in the header or the back to top files changes. */
(function () {
  if (window.MxReveal) return;
  window.MxReveal = true;
  var S = {
    HEADER: true,      // false = the bar stays on screen (as before)
    BTT: true,         // false = back to top as before
    HIDE_AFTER: 35,     // px scrolled down (away from the top) before the bar slides away
    SHOW_AFTER: 8.5       // px scrolled up before it slides back
  };
  var hd = document.querySelector('[data-mxh]');
  var nb = document.querySelector('[data-mxh-nb]');
  var btt = document.querySelector('.mxdvs-btt');
  var lastY = Math.max(0, window.scrollY), down = 0, up = 0, dirDown = false, fromTop = false;
  var hidden = false, raf = 0;

  function has(c) { return !!hd && hd.classList.contains(c); }
  function atTop() { return has('is-solid') || has('is-home-top') || (has('is-home-float') && !has('is-in')); }
  function busy() {
    return has('is-open') ||
      !!document.querySelector('#Details-menu-drawer-container.menu-opening, details-modal.header__search details[open], [data-mxh-drop].is-on, [data-mxh-cwin].is-on');
  }
  function els() { return [hd, nb].filter(Boolean); }
  /* top = leaving from the top of the page: the white header goes with the fast curve, so the glass bar
     never shows on the way out; further down it slides out as the slide in played backwards */
  function setHidden(h, instant, top) {
    if (h === hidden && !instant) return;
    hidden = h;
    els().forEach(function (el) {
      el.classList.remove('mxr-hide', 'mxr-show', 'mxr-gone', 'mxr-top');
      if (instant) { if (h) el.classList.add('mxr-gone'); return; }
      void el.offsetWidth;
      el.classList.add(h ? 'mxr-hide' : 'mxr-show');
      if (h && top) el.classList.add('mxr-top');
    });
    syncBtt();
  }
  function syncBtt() {
    if (!S.BTT || !btt) return;
    btt.classList.toggle('mxr-up', !hidden && !atTop() && lastY > 0);
  }

  function step() {
    raf = 0;
    var y = Math.max(0, window.scrollY), d = y - lastY;
    var wasTop = atTop();
    lastY = y;
    if (d > 0) {
      if (!dirDown) { dirDown = true; down = 0; fromTop = wasTop; }
      down += d; up = 0;
    } else if (d < 0) {
      if (dirDown) { dirDown = false; up = 0; }
      up -= d; down = 0;
    }
    if (!S.HEADER || !hd) { if (S.BTT && btt) btt.classList.toggle('mxr-up', !dirDown && y > 0); return; }

    if (has('is-home-top')) setHidden(false, true);          // the homepage header is part of the video
    else if (busy() || y <= 0) setHidden(false);
    else if (d > 0 && (fromTop || down >= S.HIDE_AFTER)) setHidden(true, false, fromTop);
    else if (up > 0 && up >= S.SHOW_AFTER) setHidden(false);
    syncBtt();
  }
  function queue() { if (!raf) raf = requestAnimationFrame(step); }

  /* Homepage: the header script switches to the floating bar at the end of the video and slides it in.
     While scrolling down it is put out of view in the same moment, before anything is drawn. */
  if (hd && S.HEADER) {
    new MutationObserver(function () {
      if (has('is-home-float') && dirDown && !hidden) setHidden(true, true);
    }).observe(hd, { attributes: true, attributeFilter: ['class'] });
  }
  if (S.BTT && btt) {
    document.documentElement.classList.add('mxr-btt');
    syncBtt();
  }
  window.addEventListener('scroll', queue, { passive: true });
  document.addEventListener('click', function () { setTimeout(queue, 0); }, true);
})();
